import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TokenAuthMutation } from 'src/graphql';
import { EUserRoles } from 'src/typings/base-types';
import { ELsKey, ls } from 'src/utils/localStorage';

export type TAuthState = {
  tokenAuth: TokenAuthMutation['tokenAuth'] | null;
};

export const initialAuthState: TAuthState = {
  tokenAuth: ls.get(ELsKey.TOKEN_AUTH) || null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {
    setTokenAuth(state, action: PayloadAction<TAuthState['tokenAuth']>) {
      state.tokenAuth = action.payload;
    },
    setUserRole(state, action: PayloadAction<EUserRoles>) {
      if (state.tokenAuth) {
        state.tokenAuth.userRole = action.payload;
      }
    }
  },
});

// Actions
export const { setTokenAuth, setUserRole } = authSlice.actions;

// Reducer
export const authReducer = authSlice.reducer;
